// extracted by mini-css-extract-plugin
export default {"root":"EditLLPADetailsDialog_root__Xn5Oe"};